import CountdownTimerController from './countdown-timer-controller';

export default class CartAbandonmentCountdownTimerController extends CountdownTimerController {
  declare readonly element:HTMLElement;

  declare readonly countdownEndValue:string;

  declare readonly mobileDisableWidthValue:number;

  declare readonly daysTextValue:string;

  declare readonly hoursTextValue:string;

  declare readonly minutesTextValue:string;

  declare readonly secondsTextValue:string;

  declare readonly inlineValue:boolean;

  declare readonly hasMobileDisableWidthValue:boolean;

  declare countdownDate:number;

  declare days:number;

  declare hours:number;

  declare minutes:number;

  declare seconds:number;

  static values = {
    mobileDisableWidth: Number,
    countdownEnd: String,
    daysText: String,
    hoursText: String,
    minutesText: String,
    secondsText: String,
    inline: Boolean,
  }

  timer = null;

  connect() {
    super.connect();
  }

  updateTimer = () => {
    const now = new Date().getTime();
    const distance = this.countdownDate - now;

    this.minutes = super.calculateTimerValue({ part: 'minutes', distance });
    this.seconds = super.calculateTimerValue({ part: 'seconds', distance });

    this.renderInlineOutput();

    super.flagLoaded();

    if (distance < 0) {
      clearInterval(this.timer);
      const event = new CustomEvent('timer-reached-zero');
      window.dispatchEvent(event);
    }
  }

  renderInlineOutput() {
    const output:string[] = [
      `${this.minutes}${this.minutesTextValue}`,
      `${this.seconds}${this.secondsTextValue}`,
    ];

    this.element.innerHTML = output.join(' : ');
  }
}
